// extracted by mini-css-extract-plugin
module.exports = {"padding":"Tooltip_padding__1sx2E","text":"Tooltip_text__2rvmL"};